


















































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { VBTooltip, VBToggle, BCollapse, BTooltip } from 'bootstrap-vue';

interface HTMLElement {
  clickOutsideEvent: () => void;
}

@Component({
  name: "Sidebar",
  components: {
    AgroIcons,
    BCollapse,
    BTooltip,
  },
  directives: {
    BTooltip: VBTooltip,
    BToggle: VBToggle,
  },
})
export default class Sidebar extends Vue {
  @Prop({ type: String, default: "User Name" })
  private readonly userName!: string;

  private isExpanded = false;

  private get currentRoute() {
    return this.$route.name;
  }

  private get isAnalysisRoute(): boolean {
    return this.currentRoute === 'analitica' || this.currentRoute === 'sentinela';
  }

  private handleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  private close() {
    this.isExpanded = false;
  }

  private hideSubMenuTooltip(target: string) {
    this.$root.$emit('bv::hide::tooltip', target);
  }

  private notIntegration() {
    return sessionStorage.getItem('integration') !== 'true';
  }

  @Emit("logout:request")
  private requestLogout() {
    return;
  }

  private get isAdminUser() {
    return this.$store.getters['user/isAdminUser'];
  }

  get token() {
    return this.$store.state.auth.accessToken;
  }

  private ruraluno() {
    window.open( process.env.VUE_APP_RURAL_UNO_URL + "=" + this.token, '_blank');
  }

}
